import { CSSObject } from "@emotion/react";
import {
  constants,
  mediaQueryStyles,
  type FilterChipStyleOverrides,
  type AngelouCSS,
} from "@newsela/angelou";

import { rootChipCss } from "@/search/NewSearchPageMVP/FilterPanel/FilterPanel.styles";
import { SEARCH_PAGE_BREAKPOINTS } from "@/search/NewSearchPageMVP/NewSearchPageMVP.constants";

const { mediaQuery: breakpoint } = mediaQueryStyles;

const white = constants.colors.ui.white[25];
const neutral50 = constants.colors.ui.neutral[50];
const darkestNeutral = constants.colors.ui.neutral[700];
const hoverGrey = "rgba(234, 235, 236, 1)";

export const contentTypesVisibilityCss: CSSObject = {
  display: "none",

  [breakpoint.upTo(SEARCH_PAGE_BREAKPOINTS.MD)]: {
    display: "flex",
  },
};

export const contentTypesChipGroupCss: FilterChipStyleOverrides<AngelouCSS> = {
  root: {
    marginBottom: "0.5rem",
    display: "flex",
    flexWrap: "wrap",
  },
};

export const getContentTypeChipCss = (
  isActive: boolean,
): FilterChipStyleOverrides<AngelouCSS> => ({
  root: {
    ...rootChipCss,
    backgroundColor: isActive ? darkestNeutral : neutral50,
    color: isActive ? neutral50 : darkestNeutral,

    "&:hover": {
      backgroundColor: isActive ? darkestNeutral : hoverGrey,
    },

    svg: {
      height: "24px",
      width: "24px",
    },
  },

  iconContainer: {
    width: "24px",
    height: "24px",
    marginRight: "6px",
  },

  Icon: {
    root: {
      "*": {
        strokeWidth: "2px",
        ...(isActive && { stroke: white }),
      },
    },
  },
});
